import { render } from "./upload2.vue?vue&type=template&id=4032cca2"
import script from "./upload2.vue?vue&type=script&lang=js"
export * from "./upload2.vue?vue&type=script&lang=js"

import "./upload2.vue?vue&type=style&index=0&id=4032cca2&lang=scss"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__